import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestChecklistPut = {
    path: "/checklist/:id",
    method: RouteHttpVerb.PUT
};
export { locationRestChecklistPut };
